import AuthStore from 'auth/AuthStore'
import { authCache } from 'cache/authCache'
import RegionRouterStore from 'features/main/RegionRouterStore'

interface SignUpWithXeroStoreProps {
   email: string | null
   authStore: AuthStore
   regionRouterStore: RegionRouterStore
}

export default class SignUpWithXeroStore {
   sp

   constructor(sp: SignUpWithXeroStoreProps) {
      this.sp = sp
   }

   signUpWithXero = async () => {
      const email = this.sp.email
      if (email) {
         authCache.inviteeEmail.set(email)
      }
      await this.sp.authStore.signInWithXero(this.sp.regionRouterStore.pathWithoutRegion !== '/' ? {
         returnPath: window.location.pathname + window.location.search,
      } : {})
   }
}
